
import { getGoodsState, getGoodsType, getCollationRules, getCouponStatus, getDiscountType, getPublishType, getGrantObj, getPromotionType, getCycleTypes, getDayTypes } from 'enumeration/mall.js'
import { getEnumeration } from 'enumeration'
import { goodsBelongLabels, collectionsLabels } from 'json/mall-options'
import { cashCount, maxValueMethod, minValueMethod } from '@/utils/formUtils'
import timeutils from 'utils/wt-time-utils'
export default {
  goodsList (data) {
    data.forEach((item, index) => {
      item.index = index + 1
      //   item.goods_state = item.goodsDTO && item.goodsDTO.state && getGoodsState(item.goodsDTO.state)
      item.goods_state = item.goodsDTO && this.goodsStates(item.goodsDTO)
      item.goods_type = item.goodsDTO && item.goodsDTO.goodsData && item.goodsDTO.goodsData.type && getGoodsType(item.goodsDTO.goodsData.type)
      item.goods_type = (item.goods_type && item.goods_type.indexOf('产品') > -1 && item.goods_type.replace('产品', '')) || item.goods_type
      item.putOnSaleTime = item.goodsDTO && item.goodsDTO.putOnSaleTime && timeutils.format(item.goodsDTO.putOnSaleTime)
      item.mall_visible = item.goodsDTO && item.goodsDTO.goodsData && item.goodsDTO.goodsData.mallVisible ? '是' : '否'
      item.goodsBelong = item.goodsDTO && item.goodsDTO.goodsData && getEnumeration(item.goodsDTO.goodsData.goodsBelong, goodsBelongLabels)
      if (item.goodsDTO && item.goodsDTO.goodsData && item.goodsDTO.goodsData.specifications &&
        item.goodsDTO.goodsData.specifications.length > 0 && item.goodsDTO.goodsData.priceIntervalMin && item.goodsDTO.goodsData.priceIntervalMax) {
        item.final_price = '¥' + cashCount(item.goodsDTO.goodsData.priceIntervalMin, true, 2) + '-¥' + cashCount(item.goodsDTO.goodsData.priceIntervalMax, true, 2)
      } else {
        item.final_price = item.goodsDTO && item.goodsDTO.goodsData && item.goodsDTO.goodsData.finalPrice && '¥' + cashCount(item.goodsDTO.goodsData.finalPrice, true, 2)
      }
      if (item.abstractPromotionEvents && item.abstractPromotionEvents.length > 0) {
        let promotionEvents = item.abstractPromotionEvents || []
        promotionEvents.forEach(etem => {
          let promotionData = etem.promotionData || {}
          etem.promotionStatusColor = promotionData.promotionType === 'SNAP_UP' ? 'red' : (promotionData.promotionType === 'TIME_LIMIT_DISCOUNT' ? '#EF840D' : '')
          etem.promotionStartTime = timeutils.format(promotionData.startTime)
          etem.promotionEndTime = timeutils.format(promotionData.endTime)
        })
      }
      item.promotionEvent = item.promotionEvent || item.abstractPromotionEvent || {}
      item.promotionData = (item.promotionEvent && item.promotionEvent.promotionData) || null
      let promotionData = (item.promotionEvent && item.promotionEvent.promotionData) || {}
      let specifications = item.specifications || []
      item.promotionStatusColor = promotionData.promotionType === 'SNAP_UP' ? 'red' : (promotionData.promotionType === 'TIME_LIMIT_DISCOUNT' ? '#EF840D' : '')
      if (specifications.length > 1) {
        item.promotionMaxPrice = cashCount(maxValueMethod(specifications, 'price'), true, 2)
        item.promotionMinPrice = cashCount(minValueMethod(specifications, 'price'), true, 2)
      } else {
        item.promotionPrice = specifications[0] && specifications[0].price && cashCount(specifications[0].price, true, 2)
      }

      item.promotionStartTime = timeutils.format(promotionData.startTime)
      item.promotionEndTime = timeutils.format(promotionData.endTime)
    })
    return data
  },
  // 商品状态查询
  goodsStates (val) {
    let states
    if (val.state === 'PUBLISHED' && val.putOnSaleTime > (new Date()).getTime()) {
      states = '待上架'
    } else {
      states = getGoodsState(val.state)
    }
    return states
  },
  goodsDetail (data, isEdit) {
    data.putOnSaleTime = data.goodsDTO && data.goodsDTO.putOnSaleTime && timeutils.format(data.goodsDTO.putOnSaleTime)
    let promotionData = (data.abstractPromotionEvent && data.abstractPromotionEvent.promotionData) || {}
    let abstractPromotionEvents = data.abstractPromotionEvents
    let taxProjectManageDTO = data.taxProjectManageDTO || {}
    promotionData.promotionStatusColor = promotionData.promotionType === 'SNAP_UP' ? 'red' : (promotionData.promotionType === 'TIME_LIMIT_DISCOUNT' ? '#EF840D' : '')
    promotionData.promotion_type = promotionData.promotionType && getPromotionType(promotionData.promotionType)
    promotionData.start_time = promotionData.startTime && timeutils.format(promotionData.startTime)
    promotionData.end_time = promotionData.endTime && timeutils.format(promotionData.endTime)
    taxProjectManageDTO.rate = taxProjectManageDTO.sl && taxProjectManageDTO.sl + '%'
    if (data.goodsDTO && data.goodsDTO.goodsData) {
      let goodsData = data.goodsDTO.goodsData
      let vendorInfo = goodsData.vendorInfo || {}
      goodsData.provide_invoice = (goodsData.provideInvoice || goodsData.provideInvoice === false) ? goodsData.provideInvoice.toString() : null
      vendorInfo.payment_account = vendorInfo.paymentAccount && getEnumeration(vendorInfo.paymentAccount, collectionsLabels)
      goodsData.final_price = goodsData.finalPrice && cashCount(goodsData.finalPrice, true)
      goodsData.goods_belong = goodsData.goodsBelong && getEnumeration(goodsData.goodsBelong, goodsBelongLabels)
      if (goodsData.priceIntervalMin && goodsData.priceIntervalMax) {
        goodsData.final_detail_price = '¥' + cashCount(goodsData.priceIntervalMin, true) + '--¥' + cashCount(goodsData.priceIntervalMax, true)
      } else {
        goodsData.final_detail_price = goodsData.finalPrice && '¥' + cashCount(goodsData.finalPrice, true)
      }
      goodsData.afterSalesPolicyId = goodsData.afterSalesPolicyId ? goodsData.afterSalesPolicyId : 'null'
      goodsData.goods_type = goodsData.type && getGoodsType(goodsData.type)
      goodsData.cycle_type = getCycleTypes(goodsData.cycleType)
      if (goodsData.genePackage) {
        goodsData.genePackage.forEach(item => {
          item.cycle_type = item.cycleType && getCycleTypes(item.cycleType)
          item.period = (item.cycle + item.cycle_type) || null
          goodsData.genePackage_names = goodsData.genePackage_names ? (goodsData.genePackage_names + ' / ' + item.name) : item.name
        })
      }
      // 如果是编辑页面，不需要对没有规格的商品做默认规格处理
      if (!isEdit) {
        if (abstractPromotionEvents && abstractPromotionEvents.length > 0) {
          abstractPromotionEvents.forEach((item, index) => {
            let promotionDatas = item.promotionData
            promotionDatas.promotion_type = promotionDatas.promotionType && getPromotionType(promotionDatas.promotionType)
            promotionDatas.start_time = promotionDatas.startTime && timeutils.format(promotionDatas.startTime)
            promotionDatas.end_time = promotionDatas.endTime && timeutils.format(promotionDatas.endTime)
            promotionDatas.specifications = this.getSpecificationsPromotion(goodsData, item)
            //   this.$set(promotionDatas, 'specifications', this.getSpecificationsPromotion(goodsData, item.detailData, promotionDatas))
            promotionDatas.promotionStatusColor = promotionDatas.promotionType === 'SNAP_UP' ? 'red' : (promotionDatas.promotionType === 'TIME_LIMIT_DISCOUNT' ? '#EF840D' : '')
          })
        } else {
          goodsData.specifications = this.getSpecificationsPromotion(goodsData)
        }
      } else {
        let specificationsItems = (goodsData.specifications && goodsData.specifications[0] && goodsData.specifications[0].items) || []
        if (specificationsItems && specificationsItems.length > 0) {
          specificationsItems.forEach((etem, index) => {
            etem.show_price = (etem.price && cashCount(etem.price, true)) || ''
            etem.show_detail_price = (etem.price && cashCount(etem.price, true, 2)) || ''
          })
        }
      }
    }
    return data
  },
  // 规格和促销活动的处理
  getSpecificationsPromotion (goodsData, val) {
    goodsData = JSON.parse(JSON.stringify(goodsData))
    let promotionData = (val && val.promotionData) || {}
    let promotionDetailData = (val && val.detailData) || []
    let specificationsItems = (goodsData.specifications && goodsData.specifications[0] && goodsData.specifications[0].items) || []
    if (specificationsItems && specificationsItems.length > 0) {
      specificationsItems.forEach((etem, index) => {
        etem.show_price = (etem.price && cashCount(etem.price, true)) || ''
        etem.show_detail_price = etem.price && cashCount(etem.price, true, 2)
        // 促销活动跟商品 规格关联
        if (promotionDetailData) {
          promotionDetailData.forEach(item => {
            if (item.goodsId === goodsData.goodsId) {
              let discountGoodsData = item.discountGoodsData
              discountGoodsData.forEach(atem => {
                if (atem.specificationId === etem.itemId) {
                  if (promotionData.promotionType === 'SNAP_UP') {
                    etem.promotion_price = cashCount(atem.snapUpPrice, true, 2)
                  } else if (promotionData.promotionType === 'TIME_LIMIT_DISCOUNT') {
                    etem.promotion_price = cashCount(atem.discount, true, 2)
                  }
                }
              })
            }
          })
        }
      })
    } else {
      goodsData.specifications = []
      if (goodsData.specifications.length === 0) {
        goodsData.specifications.push({
          name: '',
          items: []
        })
      }
      if (promotionDetailData && promotionDetailData.length > 0) {
        promotionDetailData.forEach(item => {
          if (item.goodsId === goodsData.goodsId) {
            let discountGoodsData = JSON.parse(JSON.stringify(item.discountGoodsData))
            discountGoodsData.forEach(atem => {
              if (!atem.specificationId) {
                if (promotionData.promotionType === 'SNAP_UP') {
                  item.promotion_price = cashCount(atem.snapUpPrice, true, 2)
                } else if (promotionData.promotionType === 'TIME_LIMIT_DISCOUNT') {
                  item.promotion_price = cashCount(atem.discount, true, 2)
                }
                goodsData.specifications[0].items.push({
                  name: '默认规格',
                  show_detail_price: goodsData.finalPrice && cashCount(goodsData.finalPrice, true, 2),
                  promotion_price: item.promotion_price
                })
              }
            })
          }
        })
      } else {
        goodsData.specifications[0].items.push({
          name: '默认规格',
          show_detail_price: goodsData.finalPrice && cashCount(goodsData.finalPrice, true, 2)
        })
      }
    }
    return JSON.parse(JSON.stringify(goodsData.specifications))
    // console.log('specifications', goodsData.specifications)
  },
  goodsGroupList (data) {
    data.forEach(item => {
      item.sorting_strategy = getCollationRules(item.sortingStrategy)
      item.isSsystem = item.system ? '是' : '否'
      item.isVisible = item.visible ? '是' : '否'
      item.created_date = timeutils.format(item.createdDate)
    })
    return data
  },
  getDetectionPackageEntities (data) {
    data.forEach((item, index) => {
      item.isSelect = false
      item.index = index
      item.createdTime = timeutils.format(item.createdDate)
    })
    return data
  },

  getCouponsList (data) {
    data.forEach(item => {
      let couponData = item.couponData || {}
      item.startTime = timeutils.format(couponData.startTime)
      item.endTime = timeutils.format(couponData.endTime)
      item.startTime_day = timeutils.format(couponData.startTime, 'date')
      item.endTime_day = timeutils.format(couponData.endTime, 'date')
      item.validity_date = timeutils.format(couponData.startTime, 'date') + '至' + timeutils.format(couponData.endTime, 'date')
      item.publishType = getPublishType(item.grantType)
      item.discount = couponData.discountType === 'FIXED_AMOUNT' ? '¥' + cashCount(couponData.discount, true, 2) : cashCount(couponData.discount, true) + '折'
      item.thresholdOfAmount = couponData.thresholdOfAmount && cashCount(couponData.thresholdOfAmount, true)
      item.discountType = getDiscountType(couponData.discountType)
      item.getAmount = item.amount - item.surplusAmount
      if (item.status === 'ACTIVATED') {
        this.ACTIVATED_status(item, couponData)
        setInterval(_ => {
          this.ACTIVATED_status(item, couponData)
        }, 5000)
      } else {
        item.coupon_status = getCouponStatus(item.status)
      }
    })
    return data
  },
  ACTIVATED_status (item, couponData) {
    if (new Date().getTime() < couponData.startTime) {
      item.coupon_status = '未开始'
    } else if (new Date().getTime() >= couponData.startTime && new Date().getTime() <= couponData.endTime) {
      item.coupon_status = '进行中'
    } else if (new Date().getTime() > couponData.endTime) {
      item.coupon_status = '已结束'
    }
  },
  couponDetail (data) {
    let couponData = data.couponData || {}
    let auditInfo = data.auditInfo || {}
    couponData.discount_show = couponData.discountType === 'FIXED_AMOUNT' ? cashCount(couponData.discount, true) : couponData.discount
    couponData.discount_show_shape = couponData.discountType === 'FIXED_AMOUNT' ? cashCount(couponData.discount, true) + '元' : cashCount(couponData.discount, true) + '折'
    data.coupon_status = getCouponStatus(data.status)
    data.publishType = data.grantType === 'INVITE_NEW_USER_REWARD' ? (getPublishType(data.grantType) + '(每邀请一个新用户，邀请人获得一张)') : getPublishType(data.grantType)
    data.grantObj = getGrantObj(data.grantObject)
    couponData.thresholdOf_amount = cashCount(couponData.thresholdOfAmount, true)
    data.validity_date = timeutils.format(couponData.startTime) + '至' + timeutils.format(couponData.endTime)
    data.audit_time = timeutils.format(auditInfo.auditTime)
    return data
  },

  getPromotionList (data) {
    data.forEach((item, index) => {
      item.index = index
      item.startTime = item.promotionData && item.promotionData.startTime && timeutils.format(item.promotionData.startTime)
      item.endTime = item.promotionData && item.promotionData.endTime && timeutils.format(item.promotionData.endTime)
      item.startTime_day = timeutils.format(item.promotionData.startTime, 'date')
      item.endTime_day = timeutils.format(item.promotionData.endTime, 'date')
      item.validity_date = item.startTime && item.endTime && (item.startTime + ' 至 ' + item.endTime)
      item.promotionType = item.promotionData && item.promotionData.promotionType && getPromotionType(item.promotionData.promotionType)
      item.promotionStatus = getCouponStatus(item.status)
    })
    return data
  },
  promotionDetail (data) {
    let auditInfo = data.auditInfo || {}
    data.promotionType = data.promotionData && data.promotionData.promotionType && getPromotionType(data.promotionData.promotionType)
    data.startTime = data.promotionData && data.promotionData.startTime && timeutils.format(data.promotionData.startTime)
    data.endTime = data.promotionData && data.promotionData.endTime && timeutils.format(data.promotionData.endTime)
    data.validity_date = data.startTime && data.endTime && (data.startTime + ' 至 ' + data.endTime)
    data.promotionStatus = getCouponStatus(data.status)
    data.audit_time = auditInfo.auditTime && timeutils.format(auditInfo.auditTime)
    if (data.detailData && data.detailData.length) {
      data.detailData.forEach(item => {
        item.snapUp_price = cashCount(item.snapUpPrice, true)
        item.discount_show = cashCount(item.discount, true, 2)
        item.promotional_price = cashCount(item.promotionalPrice, true, 2)
        if (item.goodsDTO && item.goodsDTO.goodsData) {
          let goodsData = item.goodsDTO.goodsData
          if (goodsData.specifications && goodsData.specifications.length > 0 && goodsData.priceIntervalMin && goodsData.priceIntervalMax) {
            item.final_price = '¥' + cashCount(goodsData.priceIntervalMin, true) + '-¥' + cashCount(goodsData.priceIntervalMax, true)
          } else {
            item.final_price = goodsData.finalPrice && '¥' + cashCount(goodsData.finalPrice, true)
          }
        }
      })
    }
    if (data.couponsPackageData && data.couponsPackageData.length) {
      data.couponsPackageData.forEach(item => {
        let couponData = item.couponData
        item.discount = couponData.discountType === 'FIXED_AMOUNT' ? '¥' + cashCount(couponData.discount, true, 2) : cashCount(couponData.discount, true) + '折'
        item.thresholdOfAmount = couponData.thresholdOfAmount && cashCount(couponData.thresholdOfAmount, true)
      })
    }
    return data
  },
  technologyCycle (data) {
    data.period = data.testCycle && (Number(data.testCycle.match(/P(\S*)D/)[1]) + getDayTypes(data.dayType))
    data.cycle = Number(data.testCycle.match(/P(\S*)D/)[1])
    return data
  },

  bannersPositions (data) {
    data.forEach((item, index) => {
      item.index = index + 1
      item.size = item.extensionInfo.width + 'px × ' + item.extensionInfo.height + 'px'
    })
    return data
  },
  // 第三方供应商列表数据处理
  getVendorsList (data) {
    data.forEach(item => {
      let base = item.base || {}
      item.vender_type = base.typeName
    })
    return data
  }
}
